<script setup lang="ts" generic="T extends SelectableValue">
import type { Selectable, SelectableValue } from '@/components/selectBox/selectBox';

import { useStudentsSearch } from '@/hooks/search/useStudentsSearch';

import FormComboboxInput, {
  FormComboboxProps
} from '@/components/formComboboxInput/FormComboboxInput.vue';

type Props = Omit<FormComboboxProps<number>, 'options'> & {
  schoolIds?: number[];
};

const props = defineProps<Props>();

defineEmits<{
  'update:modelValue': [Selectable<number> | null];
}>();

const { studentOptions, isLoading, onQueryChange, updateSearchFilters } = useStudentsSearch(
  props.searchFilters
);

watch(
  () => props.schoolIds,
  (schoolIds) => {
    updateSearchFilters({ school_ids: schoolIds });
  },
  { immediate: true }
);
</script>

<template>
  <FormComboboxInput
    v-bind="$props"
    :isLoading="isLoading"
    :options="studentOptions"
    :onFilter="onQueryChange"
    :modelValue="modelValue as Selectable<number>"
    @update:modelValue="(value) => $emit('update:modelValue', value as Selectable<number>)"
    @open="() => onQueryChange('')"
  />
</template>
